import { AppRole } from '@/interfaces/entities/app.role';

export default function showUserRole(role: AppRole) {
	if (role === AppRole.Therapist) {
		return 'health professional';
	}
	return role;
}
